// utils/getRootData.ts
export default function getRootData<T = unknown>(id = 'root-data'): T | null {
  // 1. 기존 root-data element 확인
  const el = document.getElementById(id);
  if (el && el.textContent) {
    try {
      return JSON.parse(el.textContent) as T;
    } catch (e) {
      console.error('Invalid JSON in root-data:', e);
    }
  }

  // 2. Inertia page 데이터 감지 (<script data-page="..." type="application/json"> 또는 <div data-page="...">)
  try {
    const scriptTag = document.querySelector('script[data-page][type="application/json"]');
    if (scriptTag?.textContent) {
      const page = JSON.parse(scriptTag.textContent);
      if (page?.props) {
        return page.props as T;
      }
    }

    const rootEl = document.getElementById('root');
    if (rootEl?.dataset?.page) {
      const page = JSON.parse(rootEl.dataset.page);
      if (page?.props) {
        return page.props as T;
      }
    }
  } catch (e) {
    console.error('Failed to parse Inertia page JSON in getRootData:', e);
  }

  return null;
}
